import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Loading } from '../../components/Loading';
import { UserBadge } from './UserBadge';
import { useDispatch } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { ErrorMessageBox } from 'bf-library';
import { initialAuthenicate } from '../auth/ducks/auth';
import { useParams } from "react-router-dom";

export const UserBadgeList = () => {
    const dispatch = useDispatch();
    const { user } = useParams();
    const auth = useSelector(state => state.auth);
    const queryClient = useQueryClient();

    const { data: badgeList, isLoading, isError, error } = useQuery({
        queryKey: ['user/badge/list', user],
        queryFn: () => Api.get(`/api/user/${user}/badge/all`),
    });

    const activeBadgeMutate = useMutation({
        mutationFn: (userBadge) => {
            return Api.get(`/api/user/badge/${userBadge.id}/profile`)
        },
        gcTime: 0,
        staleTime: 0,
        onSuccess: (res, nextBadge) => {
            //목록에서 활성화 갱신
            const oldBadgeList = queryClient.getQueryData(['user/badge/list', user]);
            const newBadgeList = oldBadgeList.data.map(badge => {
                badge.active = (nextBadge.id === badge.id);
                return badge;
            });
            queryClient.setQueryData(['user/badge/list', user], { ...oldBadgeList, data: newBadgeList });

            // 상단 프로필에 갱신
            const oldUserInfo = queryClient.getQueryData(['user/info', Number(user)]);
            queryClient.setQueryData(['user/info', Number(user)], { ...oldUserInfo, data: { ...oldUserInfo.data, badgeId: nextBadge.id, image: nextBadge.badgeImage } });

            dispatch(initialAuthenicate());
        }
    });
    // useEffect(() => scrollToElement('lnb'), [])

    const onChangeProfile = useCallback((userBadge) => {
        if (auth.id !== Number(user)) return;
        if (activeBadgeMutate.isPending) return;
        if (!window.confirm('대표 뱃지로 지정하시겠습니까?')) return;
        activeBadgeMutate.mutate(userBadge);
        return null;
    }, [activeBadgeMutate, auth, user]);

    const renderList = useMemo(() => {
        if (isLoading) return <Loading />;
        if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;
        if (badgeList.data?.length <= 0) return <div className="no_data text-center"><p>뱃지가 없습니다.</p></div>;

        return badgeList.data?.map((userBadge) => <UserBadge key={userBadge.id} userBadge={userBadge} onChangeProfile={onChangeProfile} />);
    }, [isLoading, badgeList, onChangeProfile, isError, error]);

    return (
        <div className="inner">
            <div className="userBadgeListContainer">
                <div className="badgeList_info">
                    <div className="title">전체 뱃지</div>
                    <div className="countInfo">
                        총 <strong>{badgeList?.data?.length | 0}</strong> 개의 뱃지가 있습니다
                    </div>
                </div>
                <div className="badgeList">
                    {renderList}
                    <UserBadge 
                        userBadge={{
                            id: 0,
                            badgeImage: `${process.env.PUBLIC_URL}/static/images/user/basic_badge.png`,
                            badgeName: '뱃지 없음',
                            badgeDescription: '뱃지가 없어 ㅠㅠ',
                            active: badgeList?.data?.find(b => b.active) === undefined
                        }}
                        onChangeProfile={onChangeProfile} />
                </div>
            </div>
        </div>
    );
};